import {
  Box,
  Card,
  CardActionArea,
  Checkbox,
  Typography,
  Grid,
} from "@material-ui/core";
import React, { Component, Fragment } from "react";
import { dateHelperService } from "../../../services/date-helper.service";
import { withStyles } from "@material-ui/styles";
import FormFillerService from "../../../services/review-portal-services/form-filler.service";
import { NA, N_A } from "../../../constants/Constants";
import clsx from "clsx";
import { FORM_STATUS } from "../../utilities/Constants";
import { fetchAllSites } from "../../../services/api-service";

const styles = (theme) => ({
  formFields: {
    fontSize: "14px",
    padding: "0px 5px",
  },
  lastName: {
    fontSize: "14px",
    padding: "0px 2px",
  },
  initialPoint: {
    paddingRight: "35px",
  },
  name: {
    fontFamily: "RobotoLight",
    fontSize: "14px",
    color: "#212121",
  },
  value: {
    color: "#212121",
    fontFamily: "RobotoLight",
    fontSize: "14px",
    fontWeight: "600",
  },
  gridContainer: {
    paddingTop: "16px",
    paddingBottom: "16px",
    justifyContent: "space-between",
  },
  checkbox: {
    paddingTop: "20px",
  },
  formName: {
    wordBreak: "break-word",
    fontSize: "16px",
    fontWeight: "600",
    color: "#212121",
    fontFamily: "RobotoLight",
  },
  gridSpacing: {
    gap: "16px",
  },
  status: {
    fontWeight: "600",
    fontFamily: "RobotoLight",
    textTransform: "capitalize",
  },
  completed: {
    color: "#001096",
  },
  rejected: {
    color: "#FE1919",
  },
  inProgress: {
    color: "#E9745D",
  },
  approved: {
    color: "#22B40C",
  },
});

class FormListView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
      selected: [],
      sites: [],
      formData: {},
      showFormData: false,
      isSelectedFormId: "",
    };
    this.isChecked = false;
    this.isSingleSelect = false;
    this.onSelectForm = this.onSelectForm.bind(this);
  }

  componentDidMount() {
    fetchAllSites().then((response) => {
      this.setState({
        sites: response,
      });
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.clearAllSelected !== this.props.clearAllSelected) {
      this.setState({
        selected: [],
        isSelectedFormId: "",
      });
    }
  }

  getCategory(form, name) {
    let filtered = form.formCategories.filter(
      (formCategory) => formCategory.categoryType === name,
    );
    if (filtered.length) {
      return filtered[0].categoryName;
    } else {
      return "NA";
    }
  }

  onSelectCheckbox = (itemId) => {
    this.isChecked = true;
    const checkedIndex = this.state.selected.findIndex(
      (element) => element === itemId,
    );
    let newSelected = [];
    if (checkedIndex === -1) {
      newSelected = newSelected.concat(this.state.selected, itemId);
    } else if (checkedIndex === 0) {
      newSelected = newSelected.concat(this.state.selected.slice(1));
    } else if (checkedIndex === this.state.selected.length - 1) {
      newSelected = newSelected.concat(this.state.selected.slice(0, -1));
    } else if (checkedIndex > 0) {
      newSelected = newSelected.concat(
        this.state.selected.slice(0, checkedIndex),
        this.state.selected.slice(checkedIndex + 1),
      );
    }
    if (newSelected.length > 0) {
      this.isChecked = true;
    } else {
      this.isChecked = false;
    }
    this.setState({
      selected: newSelected,
    });
    this.props.showFormDataFromCheckBox(newSelected, newSelected.length);
  };

  onSelectForm(item, event) {
    if (this.isChecked === false) {
      this.props.showFormDataFromCard(item.formDataId);
      this.setState({
        isSelectedFormId: item.formDataId,
      });
    } else {
      this.isChecked = false;
    }
    this.props.handleClickedItem(item.formDataId);
  }

  selectedFormColor = (id) => {
    if (this.state.isSelectedFormId === id) {
      this.isSingleSelect = true;
    } else {
      this.isSingleSelect = false;
    }
    return this.isSingleSelect;
  };

  render() {
    const { classes } = this.props;
    return (
      <Fragment>
        {this.props.noResultMessage.length === 0 ? (
          this.props.forms.map(({ ...item }, index) => (
            <Card
              square
              variant="outlined"
              key={index}
              style={{
                background:
                  this.state.isSelectedFormId != "" &&
                  this.state.isSelectedFormId == item.formDataId
                    ? "rgb(233 232 235)"
                    : this.state.selected.includes(item.formDataId)
                      ? "#e5f7f9"
                      : "",
              }}
              onClick={(event) => this.onSelectForm(item, event)}
            >
              <CardActionArea>
                <Box>
                  <Grid className={classes.gridContainer} container>
                    <Checkbox
                      onClick={(event) =>
                        this.onSelectCheckbox(item.formDataId)
                      }
                      className={classes.checkbox}
                      checked={
                        this.state.selected.indexOf(item.formDataId) > -1
                      }
                    />

                    <Grid container xs={4} spacing={2}>
                      <Grid container xs={12}>
                        <Typography
                          variant="body1"
                          className={classes.formName}
                        >
                          {item.formName}
                        </Typography>
                      </Grid>
                      <Typography variant="body2" className={classes.name}>
                        Windfarm:{" "}
                        <span className={classes.value}>
                          {item.siteName ? item.siteName : NA}
                        </span>
                      </Typography>
                    </Grid>

                    <Grid
                      container
                      direction="column"
                      xs={2}
                      spacing={2}
                      className={classes.gridSpacing}
                    >
                      <Box>
                        <Typography variant="body2" className={classes.name}>
                          Record Id:
                        </Typography>
                        <Typography variant="caption" className={classes.value}>
                          {item.formDataId}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography variant="body2" className={classes.name}>
                          Turbine
                        </Typography>
                        <Typography
                          variant="caption"
                          className={classes.value}
                          style={{ wordBreak: "break-word" }}
                        >
                          {item?.turbineId
                            ? `${item?.turbineName} | ${item?.turbineId}`
                            : N_A}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid
                      container
                      xs={4}
                      spacing={1}
                      className={classes.gridSpacing}
                    >
                      <Box>
                        <Typography variant="body2" className={classes.name}>
                          Status:
                        </Typography>
                        <Typography
                          variant="caption"
                          className={clsx(classes.status, {
                            [classes.completed]:
                              item.formStatus?.toUpperCase() ===
                              FORM_STATUS.COMPLETED?.toUpperCase(),
                            [classes.rejected]:
                              item.formStatus?.toUpperCase() ===
                              FORM_STATUS.REJECTED?.toUpperCase(),
                            [classes.inProgress]:
                              item.formStatus?.toUpperCase() ===
                              FORM_STATUS.INPROGRESS?.toUpperCase(),
                            [classes.approved]:
                              item.formStatus?.toUpperCase() ===
                              FORM_STATUS.APPROVED?.toUpperCase(),
                          })}
                        >
                          {item.formStatus}
                        </Typography>
                      </Box>

                      <Box>
                        <Typography variant="body2" className={classes.name}>
                          {item.formStatus === FORM_STATUS.INPROGRESS
                            ? "Last updated date"
                            : "Completed date"}
                        </Typography>
                        <Typography variant="caption" className={classes.value}>
                          {" "}
                          {dateHelperService.formattedDateFromUTS(
                            item.formStatus === FORM_STATUS.INPROGRESS
                              ? item.updatedDate
                              : item.completedDate,
                          )}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </CardActionArea>
            </Card>
          ))
        ) : (
          <Typography>No Search Results found</Typography>
        )}
      </Fragment>
    );
  }
}

export { FormListView };
export default withStyles(styles)(FormListView);
